import { createFileRoute, redirect } from '@tanstack/react-router';

import { OAuthProvider } from '#modules/user/features/auth/constants/providers';
import { accountCardId } from '#modules/user/features/profile/components/Settings/Accounts/accountRows';

/**
 * Прежний «Аккаунт» разрезан на три раздела (23.09.2026), и этот адрес теперь только отправляет
 * дальше: на него ведут письма, закладки и старые сборки приложения.
 *
 * Якорь решает куда. «#account-google» - это способ входа, и карточка Google живёт во «Входе и
 * безопасности»; остальные «#account-…» - игровые аккаунты. Без якоря - во «Вход и безопасность»:
 * сюда чаще всего вели подтверждение почты, сброс пароля и удаление аккаунта.
 */
export const Route = createFileRoute(
  '/{-$locale}/_layout/_dashboard/_authed/dashboard/settings/_settings/account'
)({
  ssr: false,
  beforeLoad: ({ location, params }) => {
    const hash = location.hash;
    const toConnections =
      hash.startsWith('account-') && hash !== accountCardId(OAuthProvider.GOOGLE);

    throw redirect({
      to: toConnections
        ? '/{-$locale}/dashboard/settings/connections'
        : '/{-$locale}/dashboard/settings/security',
      params,
      hash: hash || undefined,
      replace: true,
    });
  },
});
